export const FEDERAL_STATE_URLS = {
  GET_FEDERAL_STATES: '/admin-states',
  GET_SINGLE_FEDERAL_STATE: '/admin-states/:id',
  CREATE_FEDERAL_STATE: '/admin-states',
  UPDATE_FEDERAL_STATE: '/admin-states/:id',
  DELETE_FEDERAL_STATE: '/admin-states/:id'
};
